import React from 'react'
import { Modal } from '@arvoreeducacao/bonsai-ds'
import { createPortal } from 'react-dom'
import { useTranslation } from 'i18n'
import ContentIndicationForm from 'components/indications/content-indication-form'

const ModalIndication = ({
  contentType,
  modalVisibility,
  handleModalVisibility,
  handleSuccessMessage,
  indicationWithBookName,
  setIsOpen = undefined,
  onClose = null
}) => {
  const { t } = useTranslation()

  function handleIndicationCompleted() {
    handleModalVisibility(false)
    handleSuccessMessage()
    setIsOpen?.(false)
  }

  function close() {
    onClose?.()
    handleModalVisibility(false)
  }

  return createPortal(
    <Modal
      isOpen={modalVisibility}
      type="standard"
      size="small"
      title={t('Indicar')}
      titleSize={4}
      hasDesktopCloseButton
      onClose={close}
      center
      sheetHeaderProps={{
        type: 'close',
        title: t('Indicar')
      }}
    >
      <ContentIndicationForm
        contentType={contentType}
        onCompleteIndication={handleIndicationCompleted}
        preselectedBook={indicationWithBookName}
      />
    </Modal>,
    document.getElementById('modal')
  )
}

export default ModalIndication
